import * as ApiClient from "./../services/ApiClient";
import { requestColumns, receiveColumns } from "./columns";
import { receiveColumnsFailure } from "./results";
import {
  setFilterValue,
  addToMultiFilterValue,
  removeFromMultiFilterValue,
  addDisplayField,
  removeDisplayField,
  setSortOrder,
  setAggReport,
  setApiUrls,
  setBrowserLocation,
} from "./query";

import { StoreState } from "../types";
import { encodeBrowserPathFromState } from "./browserEncode";
import * as browserLocation from "../services/BrowserLocation";

// async actions to be called
// see also https://redux.js.org/advanced/asyncactions#actions-js-asynchronous

export function fetchResults(query: any, apiPath: string) {
  return function(dispatch: any, getState: any) {
    dispatch(setApiUrls(query, apiPath));
  };
}

export function fetchColumnMetadata(docsPath: string) {
  return function(dispatch: any) {
    dispatch(requestColumns());
    return ApiClient.fetchColumnData(docsPath)
      .then(response => {
        dispatch(receiveColumns(response));
      })
      .catch((error: Error) => {
        dispatch(receiveColumnsFailure(error));
      });
  };
}

// Setting browser location
export function updateBrowserLocation(state: StoreState.All) {
  return function(dispatch: any) {
    const newLocation = encodeBrowserPathFromState(state.query);
    dispatch(setBrowserLocation(newLocation));
    browserLocation.setLocation(newLocation);
    dispatch(fetchResults(state.query, state.config.apiPath));
  };
}

// Common actions we want to do after every filter update
function onQueryUpdate(dispatch: any, state: StoreState.All) {
  dispatch(updateBrowserLocation(state));
  dispatch(fetchResults(state.query, state.config.apiPath));
}

// Every time we update the filter or sort, we want to trigger a data load.
// These compound actions first call the basic 'set' action...
// then grab the updated state of the query params, and use it to fetch fresh results.

export function updateFilter(filterField: string, filterValue: string | string[]): any {
  return function(dispatch: any, getState: any) {
    dispatch(setFilterValue(filterField, filterValue));
    onQueryUpdate(dispatch, getState());
  };
}

export function addToMultiFilter(
  filterField: string,
  filterValues: string[],
): any {
  return function(dispatch: any, getState: any) {
    dispatch(addToMultiFilterValue(filterField, filterValues));
    onQueryUpdate(dispatch, getState());
  };
}

export function removeFromMultiFilter(
  filterField: string,
  filterValues: string[],
): any {
  return function(dispatch: any, getState: any) {
    dispatch(removeFromMultiFilterValue(filterField, filterValues));
    onQueryUpdate(dispatch, getState());
  };
}

export function addDisplayFields(newDisplayFields: string[]): any {
  return function(dispatch: any, getState: any) {
    dispatch(addDisplayField(newDisplayFields));
    onQueryUpdate(dispatch, getState());
  };
}

export function removeDisplayFields(removedField: string): any {
  return function(dispatch: any, getState: any) {
    dispatch(removeDisplayField(removedField));
    onQueryUpdate(dispatch, getState());
  };
}

export function updateSortOrder(newSortField: any, newSortOrder: any): any {
  return function(dispatch: any, getState: any) {
    dispatch(setSortOrder(newSortField, newSortOrder));
    onQueryUpdate(dispatch, getState());
  };
}

export function updateAggReport(aggReport: StoreState.Query["aggReport"]): any {
  return function(dispatch: any, getState: any) {
    dispatch(setAggReport(aggReport));
    onQueryUpdate(dispatch, getState());
  };
}
